// extracted by mini-css-extract-plugin
module.exports = {"danxv3u":"danxv3u"};